export default __webpack_public_path__ + "static/media/usdc.f08e02b1.svg";